import { useUrlLocale } from '../i18n/url-locale';
import { getFaqContent, paragraphs } from '../lib/content';
import { usePageTitle } from '../lib/use-page-title';

/**
 * Every answer is visible in the HTML (no accordion that hides text until a
 * script runs), which is also what FAQPage structured data expects.
 */
export function FaqPage() {
  const locale = useUrlLocale();
  const page = getFaqContent(locale);
  usePageTitle('/faq', page.meta.title);
  return (
    <div className="container page narrow">
      <h1>{page.headline}</h1>
      <p className="lead">{page.intro}</p>
      <div className="faq-list">
        {page.items.map((item, index) => (
          <section key={item.question} className="faq-item" aria-labelledby={`faq-${index}`}>
            <h2 id={`faq-${index}`}>{item.question}</h2>
            {paragraphs(item.answer).map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
